module.exports = __webpack_public_path__ + "img/xydw.a565eb34.png";